import { get } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

// get
function getAllActiveCulturalAdvisors () {
    const URI = `${BASE_URL}/api/all-culturalAdvisors-activate`
    return get(URI, { headers })
}

function getAllActiveCulturalAdvisorsByProgram (pProgramId) {
    const URI = `${BASE_URL}/api/all-culturalAdvisors-activate/program/${pProgramId}`
    return get(URI, { headers })
}

export {
    getAllActiveCulturalAdvisors,
    getAllActiveCulturalAdvisorsByProgram
}